// Test IDs for LXRA Gallery (Phase 2, Wave A): uploads, client Selections
// ("final picks"), and per-photo Comments / Revision Requests.

export const GALLERY_UPLOAD = {
  dropzone: 'admin-gallery-upload-dropzone',
  fileInput: 'admin-gallery-upload-file-input',
  submitButton: 'admin-gallery-upload-submit-button',
  progress: 'admin-gallery-upload-progress',
  selectionLimitInput: 'admin-gallery-selection-limit-input',
  notifyButton: (slug) => `admin-gallery-notify-button-${slug}`,
  proofingButton: (slug) => `admin-gallery-proofing-button-${slug}`,
  revisionBadge: (slug) => `admin-gallery-revision-badge-${slug}`,
};

export const GALLERY_SELECTIONS = {
  toggle: (id) => `gallery-selection-toggle-${id}`,
  count: 'gallery-selection-count',
  lightboxButton: 'lightbox-selection-button',
};

export const GALLERY_COMMENTS = {
  lightboxToggle: 'lightbox-comments-toggle-button',
  panel: 'gallery-comments-panel',
  list: 'gallery-comments-list',
  item: (id) => `gallery-comment-item-${id}`,
  reply: (id) => `gallery-comment-reply-${id}`,
  textarea: 'gallery-comment-textarea',
  revisionCheckbox: 'gallery-comment-revision-checkbox',
  submitButton: 'gallery-comment-submit-button',
};

export const ADMIN_PROOFING = {
  dialog: 'admin-proofing-dialog',
  tabSelections: 'admin-proofing-tab-selections',
  tabComments: 'admin-proofing-tab-comments',
  selectionsEmpty: 'admin-proofing-selections-empty',
  commentsEmpty: 'admin-proofing-comments-empty',
  commentRow: (id) => `admin-proofing-comment-${id}`,
  resolveButton: (id) => `admin-proofing-comment-resolve-${id}`,
  deleteButton: (id) => `admin-proofing-comment-delete-${id}`,
  replyButton: (id) => `admin-proofing-comment-reply-${id}`,
  replyTextarea: (id) => `admin-proofing-comment-reply-textarea-${id}`,
  replySubmit: (id) => `admin-proofing-comment-reply-submit-${id}`,
  replyCancel: (id) => `admin-proofing-comment-reply-cancel-${id}`,
  replyText: (id) => `admin-proofing-comment-reply-text-${id}`,
};

// LXRA Gallery Phase 2 Wave B: resolution downloads, ZIP, share links, before/after
export const GALLERY_DOWNLOAD = {
  resolutionOption: (key) => `lightbox-download-resolution-${key}`,
  allButton: 'gallery-download-all-button',
  dialog: 'gallery-download-all-dialog',
  scopeSelect: 'gallery-download-scope-select',
  resolutionSelect: 'gallery-download-resolution-select',
  submitButton: 'gallery-download-all-submit-button',
};

export const SHARE_LINK = {
  adminButton: (slug) => `admin-gallery-share-button-${slug}`,
  dialog: 'admin-share-link-dialog',
  expirySelect: 'admin-share-link-expiry-select',
  generateButton: 'admin-share-link-generate-button',
  copyButton: 'admin-share-link-copy-button',
  revokeButton: 'admin-share-link-revoke-button',
  urlText: 'admin-share-link-url-text',
};

export const SHARED_GALLERY_PAGE = {
  root: 'shared-gallery-page',
  invalid: 'shared-gallery-invalid',
  grid: 'shared-gallery-grid',
  image: (idx) => `shared-gallery-image-open-button-${idx}`,
};

export const BEFORE_AFTER = {
  adminButton: 'admin-before-after-button',
  dialog: 'admin-before-after-dialog',
  beforeSelect: 'admin-before-after-before-select',
  afterSelect: 'admin-before-after-after-select',
  captionInput: 'admin-before-after-caption-input',
  addButton: 'admin-before-after-add-button',
  deleteButton: (id) => `admin-before-after-delete-${id}`,
  section: 'gallery-before-after-section',
  slider: (id) => `gallery-before-after-slider-${id}`,
};
